import React, { useState, useEffect, useContext } from "react";
import ScheduleRoundedIcon from "@mui/icons-material/ScheduleRounded";
import { useNavigate } from "react-router-dom";
import { getRuta, simpleMessage } from "../../../helpers/Helpers";
import { getToken } from "../../../api/Account";
import { DataContext } from "../../../context/DataContext";
import { getCreditsPendienteAsync } from "../../../api/Dashboard";
import KpiCard from "../../../components/ui/KpiCard";

const PendieteCredits = ({ selectedSucursal }) => {
  const [totalNoDesembolsado, setNoDesembolsado] = useState(0);
  const { setIsLoading, setIsUnautorized } = useContext(DataContext);
  let ruta = getRuta();
  const token = getToken();
  let navigate = useNavigate();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const result = await getCreditsPendienteAsync(token, selectedSucursal);
      if (!result.statusResponse) {
        setIsLoading(false);
        if (result.error === "Unauthorized") {
          setIsUnautorized(true);
          return;
        }
        simpleMessage(result.error, "error");
        return;
      }

      setIsLoading(false);
      setNoDesembolsado(result.data.result);
    })();
  }, [selectedSucursal]);

  return (
    <KpiCard
      onClick={() => navigate(`${ruta}/clients`)}
      icon={<ScheduleRoundedIcon sx={{ fontSize: 20 }} />}
      iconBg="warning.light"
      iconColor="warning.main"
      value={totalNoDesembolsado}
      label="Pendientes de entrega"
    />
  );
};

export default PendieteCredits;
